type THttpError = Record<number, string>

type TGetHttpError = {
  httpErrors: THttpError
  status: number | undefined
}

export const getHttpError = ({
  httpErrors,
  status,
}: TGetHttpError): string | undefined => {
  return status ? httpErrors[status] : httpErrors[400]
}
